module.exports = __webpack_public_path__ + "img/1 (33).99423b7b.png";